import { gql } from '@zenbusiness/application-commons-graphql';

export const FEE_FIELDS = gql`
  fragment feeFields on Fee {
    feeType
    feeAmount
    feeAmountAdjusted
  }
`;
